
import { mapGetters } from "vuex"
import mixins from "vue-typed-mixins"
import apiErrMixin from "@/mixins/api-err"
import backButtonMixin from "@/mixins/back-button"

export default mixins(apiErrMixin, backButtonMixin).extend({
  layoutSettings: { titleToken: "common.nominantsShowcase" },

  validate ({ route }) {
    return Boolean(route.params.id)
    // store.getters["user/isAdmin"]
  },

  async asyncData ({ route, error, $api }) {
    const { id } = route.params

    const [res, err] = await $api.nominants.getNominant(id)
    const nominant = res?.items?.[0]
    if (err || !nominant) {
      error({ statusCode: 404 })
      return
    }

    return {
      nominant,
    }
  },

  data: () => ({
    nominant: null as any,
  }),

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },

  head () {
    return {
      title: this.getTitle(this.nominant.nameNominant),
    }
  },
})
